export default {
  name: 'customerProductManage',
  data () {
    /* 校验更改客户产品状态中的生效时间 */
    var checkEffectiveTime = (rule, value, callback) => {
      if (this.effectiveTimeBloooen) {
        callback() // 立即生效是的情况可为空
      } else if (!this.effectiveTimeBloooen && value) {
        callback() // 立即生效否的情况生效时间有值通过
      } else {
        if (!value) {
          return callback(new Error('立即生效"否"的状态下,生效时间不能为空'))
        }
      }
    }
    return {
      labelPosition: 'right',
      dialogFormVisible: false,
      formInline: {
        sysId: '',
        custId: '',
        custStatus: '',
        abilityId: '',
        createTime: []
      },
      sysData: [], // 业务系统列表
      custSimpleInfoList: [], // 客户名称列表
      custCopeSimpleInfoList: [], // 拼音客户名称列表
      abilityData: [], // 产品名称列表
      proCopeList: [], // 产品拼音列表
      custStateData: [
        {
          id: '0',
          value: '停用'
        },
        {
          id: '1',
          value: '启用'
        }
      ],
      page: {
        num: 1,
        sizeSmall: 10,
        size: 100
      },
      tooltip: true,
      totalRows: 100,
      tableList: [], // 列表table data
      changeRecordTable: [], // 变更记录table data
      changeRecordTotalRows: 0,
      page2: {
        num: 1,
        size: 10
      },
      custProductId: '', // 变更记录所需id
      dialogFormVisible2: false, // 客户状态弹窗
      switchStateForm: {
        custId: '',
        custProdId: '',
        custProdStatusId: '',
        custName: '',
        abilityZhName: '',
        effectImmediately: '',
        effectiveTime: '',
        reason: '',
        remark: '',
        status: ''
      },
      effectiveTimeBloooen: false,
      switchStateRule: {
        effectiveTime: [{ validator: checkEffectiveTime, trigger: 'blur' }]
      },
      dialogFormVisible3: false, // 分配通道组弹窗
      distributionForm: {
        custProductId: '',
        custId: '',
        abilityId: '',
        custName: '',
        abilityZhName: '',
        abilityDesc: '',
        desc: '',
        groupId: '',
        groupName: ''
      },
      groupList: [],
      TdTable: []
    }
  },
  activated () {
    this.queryList()
  },
  mounted () {
    this.querySearchSel()
    if (this.$route.query.num) {
      this.page.num = Number(this.$route.query.num)
      this.page.size = Number(this.$route.query.size)
      this.page.sizeSmall = Number(this.$route.query.size)
    }
    this.queryList()
  },
  methods: {
    /* 列表服务状态转换 */
    serverStatus (row) {
      if (row.status === 0) {
        return '停用'
      } else if (row.status === 1) {
        return '启用'
      } else {
        return ''
      }
    },
    /* 产品拼音搜索 */
    filterProPinYinMethod (val) {
      const pinyinMatch = require('pinyin-match')
      if (val) {
        let result = []
        this.proCopeList.forEach((v) => {
          let m = pinyinMatch.match(v.abilityZhName, val)
          if (m) {
            result.push(v)
          }
        })
        this.abilityData = result
      } else {
        this.abilityData = this.proCopeList
      }
      this.formInline.abilityId = val
    },
    clearProMatch () {
      this.abilityData = this.proCopeList
    },
    /* 客户拼音搜索 */
    filterPinYinMethod (val) {
      const pinyinMatch = require('pinyin-match')
      if (val) {
        let result = []
        this.custCopeSimpleInfoList.forEach((v) => {
          let m = pinyinMatch.match(v.custName, val)
          if (m) {
            result.push(v)
          }
        })
        this.custSimpleInfoList = result
      } else {
        this.custSimpleInfoList = this.custCopeSimpleInfoList
      }
      this.formInline.custId = val
    },
    clearMatch () {
      this.custSimpleInfoList = this.custCopeSimpleInfoList
    },
    /* 列表通道类型转换 */
    pipeTypeStatus (row) {
      if (row.pipeType === 0) {
        return '默认通道'
      } else {
        return '前置通道'
      }
    },
    // 表格通道状态值设置颜色
    cellStyle3 ({ row, rowIndex }) {
      if (row.active === 0) {
        return 'background: rgba(0,0,0,0.2)'
      } else {
        return ''
      }
    },
    querySearchSel () {
      let params = {
        pageNum: this.page.num,
        pageSize: this.page.size
      }
      let _self = this
      /* 查询所属系统列表 */
      this.$axios
        .post(this.$API.apiList.querySysList, params)
        .then(function (r) {
          _self.sysData = r.data.resData
        })
        .catch(function (error) {})
      /* 查询客户名称列表 */
      this.$axios
        .post(this.$API.rechargeManagement.queryCustSimpleInfoList, {})
        .then(function (r) {
          _self.custSimpleInfoList = r.data.resData
          _self.custCopeSimpleInfoList = r.data.resData
        })
        .catch(function (error) {})
      /* 查询产品名称列表 */
      this.$axios
        .post(this.$API.customerManagement.queryFastAbilityInfoList, {})
        .then(function (r) {
          _self.abilityData = r.data.resData
          _self.proCopeList = r.data.resData
        })
        .catch(function (error) {})
    },
    queryList () {
      let id = this.formInline.sysId
      let sysIds = []
      if (id && id !== 0) {
        sysIds.push(id)
      }
      let params = {
        pageNum: this.page.num,
        pageSize: this.page.sizeSmall,
        sysIds: sysIds,
        custId: this.formInline.custId ? this.formInline.custId : null,
        custStatus: this.formInline.custStatus
          ? this.formInline.custStatus
          : null,
        abilityId: this.formInline.abilityId ? this.formInline.abilityId : null,
        startTime: this.formInline.createTime
          ? this.formInline.createTime[0]
          : null,
        endTime: this.formInline.createTime
          ? this.formInline.createTime[1]
          : null
      }
      let _self = this
      /* 查询客户产品列表 */
      this.$axios
        .post(
          this.$API.customerManagement.queryCustomerProductBySearchCustProduct,
          params
        )
        .then(function (r) {
          _self.tableList = r.data.resData.resultList
          _self.totalRows = r.data.resData.total
        })
        .catch(function (error) {})
    },
    /* 切换状态 启用/禁用 */
    changeStatus (index, value) {
      if (value.status === 1) {
        value.status = 0
        /* 启用操作 */
        this.dialogFormVisible2 = true
        this.queryCustProdStatus(
          value.abilityId,
          value.custProductId,
          value.custName,
          value.abilityZhName,
          '1'
        )
      } else {
        value.status = 1
        /* 停用操作 */
        this.dialogFormVisible2 = true
        this.queryCustProdStatus(
          value.abilityId,
          value.custProductId,
          value.custName,
          value.abilityZhName,
          '0'
        )
      }
    },
    /* 跳转调价页面 */
    modifyPrice (index, value) {
      this.$router.push({
        path: '/customerProductModifyPrice',
        query: {
          custProductId: value.custProductId,
          abilityId: value.abilityId,
          custId: value.custId,
          custName: value.custName,
          abilityZhName: value.abilityZhName,
          price: value.price,
          num: this.page.num,
          size: this.page.sizeSmall
        }
      })
    },
    /* 分配通道组 */
    distribution (index, value) {
      this.dialogFormVisible3 = true
      this.distributionForm.custProductId = value.custProductId
      this.distributionForm.abilityId = value.abilityId
      this.distributionForm.custId = value.custId
      this.distributionForm.custName = value.custName
      this.distributionForm.abilityZhName = value.abilityZhName
      this.queryCustProdDescGroupById(value.custId, value.abilityId)
    },
    /* 分配通道组弹窗 根据客户id和产品id查描述和选中通道组id */
    queryCustProdDescGroupById (custId, abilityId) {
      let _self = this
      let params = {
        abilityId: abilityId,
        custId: custId
      }
      this.$axios
        .post(this.$API.customerManagement.queryCustProdDescGroupById, params)
        .then(function (r) {
          let data = r.data.resData
          _self.distributionForm.abilityDesc = data.abilityDesc
          _self.distributionForm.groupId = data.groupId
          _self.distributionForm.groupName = data.groupName
          _self.queryGroupListByProdId(data.abilityId)
        })
        .catch(function (error) {})
    },
    /* 分配通道组弹窗 查询通道组列表 */
    queryGroupListByProdId (prodId) {
      let _self = this
      let params = {
        prodId: prodId
      }
      this.$axios
        .get(this.$API.customerManagement.queryGroupListByProdId, {
          params: params
        })
        .then(function (r) {
          _self.groupList = r.data.resData
          if (!_self.distributionForm.groupId) {
            _self.distributionForm.groupId = _self.groupList[0].groupId
            _self.distributionForm.groupName = _self.groupList[0].groupName
          }
          if (_self.distributionForm.groupId) {
            _self.queryPipeListByGroup(
              _self.distributionForm.groupId,
              _self.distributionForm.abilityId
            )
          } else if (_self.groupList[0].groupId) {
            _self.queryPipeListByGroup(
              _self.groupList[0].groupId,
              _self.distributionForm.abilityId
            )
          }
        })
        .catch(function (error) {})
    },
    /* 根据groupId和prodId查询通道组table列表 */
    queryPipeListByGroup (groupId, prodId) {
      let _self = this
      let params = {
        prodId: prodId,
        groupId: groupId
      }
      this.$axios
        .post(this.$API.customerManagement.queryPipeListByGroup, params)
        .then(function (r) {
          _self.TdTable = r.data.resData.prodPipeRefList
        })
        .catch(function (error) {})
    },
    /* 切换通道查询table */
    changeGroup (val) {
      this.queryPipeListByGroup(val, this.distributionForm.abilityId)
    },
    closeDialog3 (formName) {
      this.dialogFormVisible3 = false
      /* 关闭对话框清除验证和表单内容 */
      this.$refs[formName].resetFields()
      this.distributionForm = {
        custProductId: '',
        custId: '',
        abilityId: '',
        custName: '',
        abilityZhName: '',
        abilityDesc: '',
        desc: '',
        groupId: '',
        groupName: ''
      }
    },
    /* 分配通道组保存 */
    saveDistribution (formName) {
      let _self = this
      /* 根据id从数组取出name */
      let _groupName = ''
      this.groupList.map(item =>{
        if (_self.distributionForm.groupId === item.groupId) {
          _groupName = item.groupName
        }
      })
      let params = {
        abilityId: this.distributionForm.abilityId,
        custId: this.distributionForm.custId,
        custProdId: this.distributionForm.custProductId,
        groupId: this.distributionForm.groupId,
        groupName: _groupName,
        remark: this.distributionForm.abilityDesc
      }
      this.$axios
        .post(this.$API.customerManagement.specifyUserProdPipeGroup, params)
        .then(function (r) {
          _self.dialogFormVisible3 = false
          _self.$message({
            type: 'success',
            message: '分配成功'
          })
          _self.queryList()
        })
        .catch(function (error) {})
    },
    /* 更改客户产品状态查询详情 */
    queryCustProdStatus (
      abilityId,
      custProdId,
      custName,
      abilityZhName,
      status
    ) {
      let _self = this
      let _custName = custName
      let _abilityZhName = abilityZhName
      let _status = status
      let params = {
        abilityId: abilityId,
        custProdId: custProdId
      }
      this.$axios
        .post(
          this.$API.customerManagement.queryCustProdStatusByCustProdId,
          params
        )
        .then(function (r) {
          _self.switchStateForm = r.data.resData
          _self.switchStateForm.custName = _custName
          _self.switchStateForm.abilityZhName = _abilityZhName
          _self.switchStateForm.status = _status
          if (r.data.resData.effectImmediately === '1') {
            _self.effectiveTimeBloooen = true
          } else if (r.data.resData.effectImmediately === '0') {
            _self.effectiveTimeBloooen = false
          } else {
            _self.switchStateForm.effectImmediately = '1'
            _self.effectiveTimeBloooen = true
          }
        })
        .catch(function (error) {})
    },
    /* 更改客户产品状态是否立即生效与生效时间联动 */
    changeEffectImmediately (value) {
      if (value === '1') {
        this.effectiveTimeBloooen = true
        this.switchStateForm.effectiveTime = ''
        this.$refs.switchStateForm.clearValidate()
      } else if (value === '0') {
        this.effectiveTimeBloooen = false
        this.switchStateForm.effectiveTime = ''
        this.$refs.switchStateForm.clearValidate()
      }
    },
    /* 关闭变更记录弹窗 */
    closeDialog2 (formName) {
      this.dialogFormVisible2 = false
      /* 关闭对话框清除验证和表单内容 */
      this.$refs[formName].resetFields()
      this.switchStateForm = {
        custId: '',
        custProdId: '',
        custProdStatusId: '',
        custName: '',
        abilityZhName: '',
        effectImmediately: '',
        effectiveTime: '',
        reason: '',
        remark: '',
        status: ''
      }
    },
    /* 保存状态 */
    saveSwitchState (formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let params = {
            custId: this.switchStateForm.custId,
            custProdId: this.switchStateForm.custProdId,
            custProdStatusId: this.switchStateForm.custProdStatusId,
            effectImmediately: this.switchStateForm.effectImmediately,
            effectiveTime: this.switchStateForm.effectiveTime,
            reason: this.switchStateForm.reason,
            status: this.switchStateForm.status
          }
          console.log(params)
          let _self = this
          this.$axios
            .post(
              this.$API.customerManagement.updateCustomerProducStatust,
              params
            )
            .then(function (r) {
              _self.dialogFormVisible2 = false
              _self.$message({
                type: 'success',
                message: '更改状态成功'
              })
              _self.queryList()
            })
            .catch(function (error) {})
        }
      })
    },
    /* 变更记录 */
    changeRecord (index, row) {
      this.dialogFormVisible = true
      this.custProductId = row.custProductId
      this.page2.num = 1
      this.queryChangeRecord()
    },
    /* 关闭变更记录弹窗 */
    closeDialog () {
      this.dialogFormVisible = false
      this.custProductId = ''
      this.changeRecordTable = []
    },
    /* 请求变更记录列表 */
    queryChangeRecord () {
      let _self = this
      let params = {
        custProductId: this.custProductId,
        pageNum: this.page2.num,
        pageSize: this.page2.size
      }
      this.$axios
        .post(
          this.$API.customerManagement
            .queryCustomerProductRecordByCustProductId,
          params
        )
        .then(function (r) {
          _self.changeRecordTable = r.data.resData.resultList
          _self.changeRecordTotalRows = r.data.resData.total
        })
        .catch(function (error) {})
    },
    /* 点击查询按钮 */
    onSearch () {
      this.page.num = 1
      this.queryList()
    },
    /* 重置操作 */
    onReset (formName) {
      this.formInline.custId = ''
      this.formInline.abilityId = ''
      this.abilityData = this.proCopeList
      this.custSimpleInfoList = this.custCopeSimpleInfoList
      this.$refs[formName].resetFields()
    },
    // 每页显示多少条
    pageSizeChange (val) {
      this.page.sizeSmall = val
      this.page.num = 1
      this.queryList()
    },
    // 当前页选择
    pageCurrentChange (val) {
      this.page.num = val
      this.queryList()
    },
    // 每页显示多少条 变更记录
    pageSizeChange2 (val) {
      this.page2.size = val
      this.page2.num = 1
      this.queryChangeRecord()
    },
    // 当前页选择 变更记录
    pageCurrentChange2 (val) {
      this.page2.num = val
      this.queryChangeRecord()
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/customerManagement/customerProductManage.js